export const ACTION_CONTANTS = {
    SHOW: "{AAE07A52-46A4-49EF-98B0-C2595BAC2382}",
    HIDE: "{7F58C8DD-D7C0-4FB7-BB44-8EC6B5E1C3D9}",
    ENABLE: "{5744A87E-E32C-42CC-862F-96842A0202BB}",
    DISABLE: "{C698C993-549E-486A-A09C-BB8D830DA958}"
}

export const MATCH_TYPE_CONTANTS = {
    ANY: "{365C94DA-C1CD-4783-A91D-0D17A16C7117}",
    ALL: "{4E50C172-7EA6-4989-82C3-75F24F80EF72}"
}

export const OPERATOR_CONSTANTS = {
    STARTS_WITH: "{FD10F291-3C2E-4AE7-8A67-2F8271CB3DF2}",
    IS_EQUAL_TO: "{1D38B217-A2EE-4E7B-B6ED-13E751462FEB}",
    IS_NOT_EQUAL_TO: "{49F47E77-E8C5-46F9-BF39-78D6B0D40B48}"
}